// extracted by mini-css-extract-plugin
module.exports = {"externalVideoLink":"style_externalVideoLink__160TwAbQFAZAQjibIWsu9v"};